import { get } from 'lodash';
//
// Some brands have a property called 'affiliationStatus', defined as:
// type affiliationStatus = 'None' | 'Affiliated' | 'Employed'
// Geisinger wants to display a label with the text 'COMMUNITY' on
// every non-affiliated provider listed in their directory.
//

export function isCommunity(provider) {
    const affiliationStatus = get(provider, 'properties.affiliationStatus');

    if (affiliationStatus) {
        return affiliationStatus === 'None';
    } else {
        return false;
    }
}
